// Per-browser, localStorage-scoped Test Mode for the admin.
// Real customers' browsers don't have this key, so they always see real prices.
const KEY = "cvc_test_mode_until";
const DURATION_MS = 10 * 60 * 1000; // 10 minutes

export function readTestModeUntil() {
  try {
    const v = localStorage.getItem(KEY);
    if (!v) return null;
    const ms = parseInt(v, 10);
    if (!ms || ms <= Date.now()) { localStorage.removeItem(KEY); return null; }
    return ms;
  } catch { return null; }
}

export function isTestModeActive() { return readTestModeUntil() !== null; }

export function enableTestMode(durationMs = DURATION_MS) {
  const until = Date.now() + durationMs;
  try { localStorage.setItem(KEY, String(until)); } catch { /* ignore */ }
  return until;
}

export function disableTestMode() {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}

export function remainingLabel() {
  const until = readTestModeUntil();
  if (!until) return null;
  const ms = until - Date.now();
  if (ms <= 0) return null;
  const m = Math.floor(ms / 60000);
  const s = Math.floor((ms % 60000) / 1000);
  return `${m}:${String(s).padStart(2, "0")}`;
}

export const TEST_MODE_DURATION_MS = DURATION_MS;
